import React from 'react';

const NotFound = () => {
    return (
        <>
        <section className="notFound">
            <div>
                <h2 className="reg-28">404</h2>
                <div className="bar lit-14">
                    <h3>This page could not be found</h3>
                </div>
            </div>
        </section>
        </>
    );
};

export default NotFound;